const initState = {
    isLoggingout : false,
    loggedout : false,
};

const logoutReducer = (state = initState, action) => {
    switch(action.type){
        case "LOGOUT":
            return{...state, isLoggingout: true,loggedout: false};
        case "LOGOUT_SUCCESS":
            return{...state, loggedout: true, isLoggingout: false};
        case "LOGOUT_FAIL":
            return{...state, isLoggingout: false, loggedout : false};
        default:
            return state;
    }
};

export default logoutReducer;